import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { formatAddress } from "@utils/StringUtils";
import { encodeCookie, removeCookie } from "@utils/CookieUtils";
import BaseAutocomplete from "@vueEntry/UIKitComponents/BaseAutocomplete.vue";
import { getPlacesAddressAutocomplete } from "@services/geographyAPI";
import { getPlaceFromGAutocomplete } from "@utils/GAutocompleteUtils";
import { defineComponent } from "vue";
export default defineComponent({
  name: "ValuationBanner",
  components: {
    BaseAutocomplete
  },
  inheritAttrs: false,
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    titleClass: {
      type: String,
      default: ""
    },
    valuationBannerParagraph: {
      type: String,
      default: ""
    },
    valuationBannerParagraphClass: {
      type: String,
      default: ""
    },
    valutinoIsVisible: {
      type: Boolean,
      default: false
    },
    isSelling: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      valuationAddress: undefined,
      hasPlace: false,
      id: Date.now(),
      disableCb: true,
      place: null
    };
  },
  computed: {
    cdn() {
      return window["_cdn"];
    },
    labels() {
      return window["_labels"];
    },
    macroTypologyDefault() {
      return window["_macroTypologyDefault"];
    },
    buttonClass() {
      return this.hasPlace ? "tw-bg-w-primary tw-cursor-pointer" : "tw-bg-w-secondary";
    }
  },
  mounted() {
    removeCookie("publicValuationRequestCookie");
  },
  methods: {
    onInputChangeCb(query) {
      return __awaiter(this, void 0, void 0, function* () {
        if (!query) return;
        var res = yield getPlacesAddressAutocomplete(query, 10);
        return res.map(r => ({
          label: r.description,
          id: r.place_id
        }));
      });
    },
    optionSelectedCb(selectedEl) {
      var _a;
      return __awaiter(this, void 0, void 0, function* () {
        var {
          place
        } = yield getPlaceFromGAutocomplete("".concat(selectedEl.id), selectedEl.label);
        this.place = place;
        this.hasPlace = true;
        this.disableCb = true;
        this.valuationAddress = {
          label: formatAddress(place.streetName, (_a = place.streetNumber) !== null && _a !== void 0 ? _a : "", place.cityName)
        };
      });
    },
    submit() {
      var _a;
      if (!this.hasPlace) return;
      var address = formatAddress(this.place.streetName, (_a = this.place.streetNumber) !== null && _a !== void 0 ? _a : "", this.place.cityName);
      var publicValuationCookie = {
        realEstateValuation: {
          sale: true,
          cityID: this.place.cityID,
          macroTypologyID: this.macroTypologyDefault,
          typologyID: 1,
          address: address,
          streetName: this.place.streetName,
          latitude: this.place.latitude,
          longitude: this.place.longitude
        },
        owner: this.isSelling
      };
      removeCookie("publicValuationCookie");
      encodeCookie("publicValuationCookie", publicValuationCookie);
      encodeCookie("publicValuationCookieNew", publicValuationCookie, undefined, false, true);
      window.location.href = this.labels.valuationBannerUrl;
    }
  }
});